var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-select',_vm._g(_vm._b({ref:"select",staticClass:"cs-select",scopedSlots:_vm._u([(_vm.label)?{key:"prefix",fn:function(){return [_c('span',{ref:"prefix"},[_vm._v(_vm._s(_vm.label)+":")])]},proxy:true}:null],null,true)},'el-select',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }